import { useState, useEffect } from 'react';

/**
 * Откладывает обновление `value` на `ms` миллисекунд.
 * Используется для предотвращения избыточных API-запросов при вводе текста.
 */
export function useDebounce<T>(value: T, ms: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), ms);
    return () => clearTimeout(timer);
  }, [value, ms]);

  return debouncedValue;
}
